import { assertValidVersion } from "@tsparticles/engine";
import { OutOfCanvasUpdater } from "./OutOfCanvasUpdater.js";
export async function loadOutModesUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("outModes", container => {
        return Promise.resolve(new OutOfCanvasUpdater(container));
    }, refresh);
}
